import Vue from 'vue'
import App from './App.vue'
import { router } from "./router"
import store from "./store"
//import CKEditor from '@ckeditor/ckeditor5-vue2';
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js